import { useGroupDetailsContext } from 'features/groups'
import { SummaryHeader, getResourceName } from 'features/resources'
import React from 'react'

function Header() {
  const { group } = useGroupDetailsContext()

  return (
    <div>
      <SummaryHeader
        actions={null}
        breadCrumbsItems={[
          {
            label: 'Groups',
            link: '/admin/groups'
          },
          {
            label: getResourceName(group)
          }
        ]}
        rsrcName={getResourceName(group)}
      />
      {/* {showDeleteGroupModal && (
        <DeleteGroupModal
          group={group}
          onCancel={() => setShowDeleteGroupModal(false)}
          onSuccess={() => {
            setShowDeleteGroupModal(false)
            typeof goBackFn === 'function' && goBackFn()
          }}
        />
      )}
      {showEditModal && (
        <CreateGroupModal
          group={group}
          onCancel={() => setShowEditModal(false)}
          onComplete={() => setShowEditModal(false)}
        />
      )} */}
    </div>
  )
}

export { Header }
